import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=d0e1b58a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0e1b58a')) {
      api.createRecord('d0e1b58a', component.options)
    } else {
      api.reload('d0e1b58a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=d0e1b58a&", function () {
      api.rerender('d0e1b58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/comp/childrenage.vue"
export default component.exports